import { render, staticRenderFns } from "./RecommendationPeriodSummary.vue?vue&type=template&id=ce69312c"
import script from "./RecommendationPeriodSummary.vue?vue&type=script&lang=js"
export * from "./RecommendationPeriodSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports